


































import { BasicStrengthDTO } from '../../../src_server/entity/dto/BasicStrengthDTO';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BasicStrengthDaily } from '../../../src_server/entity/generated/BasicStrengthDaily';
import { basicStrengthAllData, basicStrengthTitle } from '../../../src_server/entity/master/basicStrengthData';
import { ClassBasicStrenghtLevel } from '../../../src_server/entity/generated/ClassBasicStrenghtLevel';
import c from 'config';
import { Session } from '../../utils/Session';

class BasicStrengthDailyExt extends BasicStrengthDaily {
  public get current_level_title() {
    return this.current_level;
  }
}

@Component({
  components: {},
  filters: {
    classTarget: function (item: string) {
      return item ? '⭐️' : '';
    },
  },
})
export default class BasicStrengthPanel extends Vue {
  @Prop()
  value!: BasicStrengthDTO[];

  @Prop({
    default: () => {
      return [];
    },
  })
  classLevel!: ClassBasicStrenghtLevel[];

  getClassLevel(item: string) {
    const level = this.classLevel.find((c) => basicStrengthTitle[c.strength_item!] === item);
    if (!level || !level.strength_item) return '';
    return level.strength_item;
  }

  @Prop({ default: false })
  private isViewer!: boolean;

  get isCo() {
    return Session.isCircleOBuilding();
  }

  getRowCss(dibalbedState: boolean) {
    if (dibalbedState) {
      return ['clr-gray'];
    } else {
      return ['clr-blk'];
    }
  }

  get model() {
    return this.value.map((v) => {
      const name = `${v.strength_item}${v.current_level}`;
      return {
        class_id: v.class_id,
        user_id: v.user_id,
        score: v.score,
        strength_item: basicStrengthTitle[`${v.strength_item}`],
        is_done: v.is_done,
        current_level: v.current_level,
        current_level_title: basicStrengthAllData[name],
        disabled: v.disabled,
        episode: v.episode,
      };
    });
  }

  editEpisode(value: string, index: number) {
    this.$emit('edit-episode', value, index);
  }

  selected(event: Event, index: number) {
    console.log(index);
    const check = event.target as any;
    this.$emit('change', check.checked, index);
  }
}
